import {
  UserProfileSearchResultView,
  decorateUserProfileSearchResultView,
  ImageView,
} from "~/backendApis/viewModel"
import { makeSearcher } from "~/clStores/profileSearchList"

export interface SimilarUserProfile {
  universalUid: string
  profileLinkPath: string
  fullName: string
  skillTagTexts: string[]
  profileImageUrl: string | null
  profileImage: ImageView | null
  corporationName?: string
  isCurrentCorporation?: boolean // 企業が在籍中の企業かどうかを示すフラグ
}

/**
 * 類似ユーザープロフィールを取得するための関数。
 * 効果検証を主な目的に一旦実装されているため、ロジックはプロフィール検索と全く同じものを流用している。
 */
export const similarUserProfilesGetter = () => ({
  getByLargeJobCategoryId: async (
    smallJobCategoryId: number,
    excludedUniversalUids: string[] = [] // 除外対象のユーザーID
  ): Promise<SimilarUserProfile[]> => {
    const userProfiles = await makeSearcher({
      searchWord: "",
      smallJobCategoryIds: [smallJobCategoryId],
      availableUptimeIds: [3, 4, 5], // 週3日以上
      sinceLastAccessDays: null,
      prefectureIds: [],
      minAge: null,
      maxAge: null,
    }).execute()

    const numberOfReturnedProfiles = 5

    return userProfiles.list
      .sort(() => Math.random() - 0.5) // 配列の順番をシャッフル
      .filter(
        (elm: UserProfileSearchResultView) =>
          !excludedUniversalUids.includes(elm.universalUid)
      )
      .slice(0, numberOfReturnedProfiles) // 先頭から指定された数の要素を取得
      .map((profile: UserProfileSearchResultView) => {
        const decorator = decorateUserProfileSearchResultView(profile)
        const mainExperienceCorporation = decorator.getMainExperienceCorporation()

        return {
          universalUid: profile.universalUid,
          profileLinkPath: `/profiles/${profile.universalUid}`,
          fullName: decorator.getFullName(),
          skillTagTexts: decorator.skillTagTexts(5), // タグを5つだけ格納
          profileImageUrl: profile.image?.url || null,
          profileImage: profile.image,
          corporationName: mainExperienceCorporation?.corporationName,
          isCurrentCorporation: mainExperienceCorporation?.isCurrentCorporation,
        }
      })
  },
})
